export const normalizePhoneForOtp = (dialCode, rawPhone) => {
  const raw = String(rawPhone || "").trim();
  if (!raw) return "";

  const dialDigits = String(dialCode || "").replace(/\D/g, "");
  let phoneDigits = raw.replace(/\D/g, "");

  if (raw.startsWith("+") || raw.startsWith("00")) {
    phoneDigits = raw.startsWith("00")
      ? raw.slice(2).replace(/\D/g, "")
      : phoneDigits;
    if (dialDigits && phoneDigits.startsWith(`${dialDigits}0`)) {
      phoneDigits = `${dialDigits}${phoneDigits.slice(dialDigits.length + 1)}`;
    }
    return `+${phoneDigits}`;
  }

  if (dialDigits && phoneDigits.startsWith(dialDigits)) {
    phoneDigits = phoneDigits.slice(dialDigits.length);
  }

  phoneDigits = phoneDigits.replace(/^0+/, "");
  return dialDigits ? `+${dialDigits}${phoneDigits}` : `+${phoneDigits}`;
};
export const isValidOtpPhone = (phone) => /^\+[1-9]\d{7,14}$/.test(phone);

export const getOtpErrorMessage = (error, action = "send") => {
  const status = error?.response?.status;
  const serverMessage =
    error?.response?.data?.error || error?.response?.data?.message || "";

  if (status === 429) {
    if (serverMessage) return serverMessage;
    return "Trop de tentatives ont été effectuées. Patientez quelques minutes avant de réessayer.";
  }
  if (/email already in use/i.test(serverMessage)) {
    return "Cette adresse e-mail est déjà associée à un compte.";
  }
  if (status === 400) {
    return action === "verify"
      ? "Le code de vérification n'est pas valide."
      : "Le numéro de téléphone n'est pas valide.";
  }
  if (/invalid code/i.test(serverMessage)) {
    return "Le code de vérification n'est pas valide.";
  }
  if (status === 503 || /twilio|sms|service/i.test(serverMessage)) {
    return "Le service SMS est temporairement indisponible. Réessayez dans quelques minutes.";
  }
  if (serverMessage && !/error occured|otp error/i.test(serverMessage)) {
    return serverMessage;
  }

  return action === "verify"
    ? "Le code de vérification n'est pas valide."
    : "Le numéro de téléphone n'est pas valide.";
};
